import { useCallback } from 'react';
import { useLoginContext } from '../reducer/useLogin';

export const useResetLoginState = () => {
  const [state, dispatch] = useLoginContext();
  const data = state.data;
  return useCallback(() => {
    if (data.type === 'VERIFYING_OTP') {
      dispatch({
        type: 'REQUESTING_OTP',
        phoneNumber: data.phoneNumber,
      });
    }
  }, [data, dispatch]);
};
